// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d20c3d9b","455":"5e5dc599","977":"e7d630e9"}[chunkId] + ".chunk.js";
};